import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  @ViewChild('megaMenu') megaMenu!: ElementRef;

  constructor() { }
  isMenuOpen = false;

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }
  closeMenu() {
    debugger;
    if (this.megaMenu) {
      this.megaMenu.nativeElement.classList.remove('show');
    }
    this.isMenuOpen = false;
  }
  
  ngOnInit(): void {
  }

}
